export const validation = {
  country: 'Country is required',
  serviceType: 'Service type is required',
  bookingSuccess: 'Booking Added Successfully',
  selectProvider: 'Please select provider',
  selectAtLeastOneProvider: 'Please select at least one provider',
  bookingDate: 'Booking date is required',
  slot: 'Please select slot',
  bookingTime: 'Please select a time after 1 hour',
};
